import Image from "next/image";

const features = [
  {
    icon: "/assets/calendar.png",
    alt: "calendar",
    text: "Réservation 24/7",
    width: 41,
    height: 36,
  },
  {
    icon: "/assets/store.png",
    alt: "store",
    text: "Retrait gratuit en magasin",
    width: 40,
    height: 35,
  },
  {
    icon: "/assets/truck.png",
    alt: "truck",
    text: "Livraison sur chantier",
    width: 48,
    height: 30,
  },
  {
    icon: "/assets/security.png",
    alt: "security",
    text: "Satisfaction garantie",
    width: 40,
    height: 47,
  },
];

export function ToolouerSection() {
  return (
    <section className="bg-secondary py-10 md:rounded-3xl mt-8 max-w-[1180px] mx-auto">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="flex items-center justify-center gap-3 mb-8">
          <p className="text-white text-xl italic">Chez</p>
          <Image
            src="/assets/white-logo.png"
            alt="Toolouer"
            width={160}
            height={40}
            className="h-10 w-auto"
          />
          <p className="text-white text-xl italic">c&apos;est...</p>
        </div>

        {/* Features */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {features.map((feature) => (
            <div
              key={feature.alt}
              className="flex flex-col items-center text-center gap-4"
            >
              <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center">
                <Image
                  src={feature.icon}
                  alt={feature.alt}
                  width={feature.width}
                  height={feature.height}
                />
              </div>
              <p className="text-white text-sm md:text-base font-medium">
                {feature.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
